import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router'

export const Route = createFileRoute('/app/series/$seriesId/edit')({
  component: lazyRouteComponent(() => import('./-edit')),
})
